// Mirrors the hub's `listing` review check (PLAN §3): English must carry all of these.
export const LISTING_LOCALES = ["en", "ru"];
export const REQUIRED_LISTING_FIELDS = ["tagline", "description", "privacy_url", "support_url", "data_retention_text"];

export function listingGaps(listing) {
  const gaps = REQUIRED_LISTING_FIELDS.filter((f) => !String(listing?.[f] || "").trim());
  const shots = Array.isArray(listing?.screenshots) ? listing.screenshots.filter(Boolean) : [];
  if (!shots.length) gaps.push("screenshots");
  return gaps;
}

export const MIN_JUSTIFICATION = 20;

export function weakJustifications(version) {
  const notes = version?.scope_justifications || {};
  return (version?.scopes || []).filter((s) => String(notes[s] || "").trim().length < MIN_JUSTIFICATION);
}
